import { createLocale } from "./createLocale";

export const el = createLocale({
  header: {
    title: "Βγείτε παγκόσμια. 2 $ ανά Short. Σε οποιαδήποτε γλώσσα!",
    subtitle: "🔥Πληρώστε μόνο για αποτέλεσμα – από $0.089 έως $0.009 ανά δευτερόλεπτο🔥",
  },
  steps: {
    uploadVideo: "Μεταφόρτωση βίντεο",
    selectLanguages: "Επιλογή γλωσσών",
    conversionResult: "Μετατροπή και αποτέλεσμα",
  },
  upload: {
    dragAndDrop: "Σύρετε και αποθέστε το αρχείο βίντεο εδώ",
    orClickToSelect: "ή κάντε κλικ για επιλογή",
    supportedFormats: "Υποστηριζόμενες μορφές: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Μέγιστο μέγεθος αρχείου: 200 MB",
    maxDuration: "• Μέγιστη διάρκεια: 30 δευτ.",
    chooseFile: "Επιλογή αρχείου",
    selectedFile: "Επιλεγμένο αρχείο:",
    size: "Μέγεθος:",
    fileTypeError: "Παρακαλώ επιλέξτε αρχείο βίντεο",
    fileSizeError: "Το μέγεθος του αρχείου ({size} MB) υπερβαίνει το μέγιστο όριο των 200 MB",
    durationError: "Η διάρκεια του βίντεο ({duration} δευτ.) υπερβαίνει το μέγιστο όριο των 30 δευτ.",
    fileReadError: "Δεν είναι δυνατή η ανάγνωση του αρχείου βίντεο. Δοκιμάστε άλλο αρχείο.",
  },
  languages: {
    sourceAudioLanguage: "Γλώσσα αρχικού ήχου",
    targetAudioLanguage: "Γλώσσα ήχου στόχου",
    selectLanguage: "Επιλέξτε γλώσσα...",
  },
  conversion: {
    replaceAudio: "Κλωνοποίησε τη φωνή μου",
    uploadVideoAndSelectLanguages: "Ανεβάστε ένα βίντεο και επιλέξτε γλώσσες για να συνεχίσετε",
  },
  nav: {
    blog: "Ιστολόγιο",
  },
  footer: {
    privacyPolicy: "Πολιτική απορρήτου",
    termsOfUse: "Όροι χρήσης",
  },
  languageOptions: {
    el: "Ελληνικά",
  },
});
